$(function () {
  $(".image-text-tabs__heading").on("click", function () {
    const $parent = $(this).closest(".image-text-tabs-content");
    const index = $(this).data("index");

    $(".image-text-tabs__heading").removeClass("active");
    $(this).addClass("active");

    $parent.find(".image-text-tabs__block").hide();
    $parent.find(".image-text-tabs__block-" + index).show();
  });

  $(".items-card-tab-heading-card").on("click", function (event) {
    event.preventDefault()
    let item = $(this).data('item');
    $(this).siblings(".items-card-tab-heading-card").removeClass("active");
    $(this).addClass("active");
    $(this).parents('.items-card-tabs-content').find('.items-card-tabs__blocks').hide();
    $(this).parents('.items-card-tabs-content').find('.items-card-tabs__blockss').hide();
    $(".items-card-tabs__blocks-"+item).show().slick('refresh');
    $(".items-card-tabs__blockss-"+item).show().slick('refresh');
  });

  $(".items-card-tab-heading-book").on("click", function (event) {
    event.preventDefault();
    let item = $(this).data("item");

    let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?tab=" + item;
    window.history.pushState({ tab: item }, "", newUrl);

    $(this).siblings(".items-card-tab-heading-book").removeClass("active");
    $(this).addClass("active");

    // ẩn/hiện block
    $(this).parents(".items-card-tabs-content").find(".items-card-tabs__blocks").hide();
    $(this).parents(".items-card-tabs-content").find(".items-card-tabs__blockss").hide();
    $(".items-card-tabs__blocks-" + item).show();
    $(".items-card-tabs__blockss-" + item).show();
  });

  $(document).ready(function () {
    let params = new URLSearchParams(window.location.search);
    let tab = params.get("tab");
    let box = params.get("box");

    if (tab) {
      $(".items-card-tab-heading-book[data-item='" + tab + "']")
        .addClass("active")
        .siblings(".items-card-tab-heading-book").removeClass("active");

      $(".items-card-tabs__blocks, .items-card-tabs__blockss").hide();
      $(".items-card-tabs__blocks-" + tab).show();
      $(".items-card-tabs__blockss-" + tab).show();
    }

    if (box) {
      let target = $("#" + box);
      if (target.length) {
        target.addClass("active");

        $("html, body").animate({
          scrollTop: target.offset().top - 100
        }, 600);
      }
    }
  });


  $(".collapsibles_tab .product__accordion-heading").click(function () {
    const $parent = $(this).closest(".collapsibles_tab");
    const $content = $parent.find(".accordion__contents");

    $(".collapsibles_tab").not($parent).removeClass("active")
      .find(".accordion__contents").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });

  $(".footer-type-link_list .footer-block__heading").click(function () {
    const $parent = $(this).closest(".footer-type-link_list");
    const $content = $parent.find(".footer-block__details-content");

    $(".footer-type-link_list").not($parent).removeClass("active")
      .find(".footer-block__details-content").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });
  
});


$(document)
  .off("click", ".cls-filter-by-concern")
  .on("click", ".cls-filter-by-concern", function () {
    let $content = $(this).parent().find(".image-text-tabs-left");

    $(this).toggleClass("active");
    $content.slideToggle();
  });


$(document).on('click', '.cls-picker_type-button label', function(e) {
  let value_alt = $(this).parent().find('input').val();
  let value_alt_handle = value_alt.trim().toLowerCase().replace(/\s+/g, '-')
  let value_title = $(this).parent().data('title');

  if (value_alt_handle != '') {
    $(".cls-option-series").hide();
    $(".cls-option-"+value_alt_handle).show();
  }

  if (value_title != '') {
    $(".product__title h1").text(value_title);
  }

  $(".product__media-list .slick-track li").each(function(index){
      let alt = $(this).data('alt');
      if(alt == value_alt){
          $('.slider-for').slick('slickGoTo', index);
      }
  });
});

$(document).ready(function () {
  let value_alt = $('.product-form__input-picker input:checked').val();
  let value_alt_handle = value_alt.trim().toLowerCase().replace(/\s+/g, '-');

  let value_title = $('.product-form__input-picker input:checked').data('title');

  if (value_alt_handle != '') {
    $(".cls-option-series").hide();
    $(".cls-option-"+value_alt_handle).show();
  }

  if (value_title != '') {
    $(".product__title h1").text(value_title);
  }
  
  $(".product__media-list .slick-track li").each(function(index){
      let alt = $(this).data('alt');
      if(alt == value_alt){
          $('.slider-for').slick('slickGoTo', index);
      }
  });

});

